import type { AppErrorOptions } from './AppError';
import { AppError } from './AppError';
import { pinClassName } from './pinClassName';

export class EmptySportShowcaseError extends AppError {
    constructor(showcaseId: string, options?: AppErrorOptions) {
        super(`Empty sport showcase: ${showcaseId}`, {
            ...options,
            context: { ...options?.context, showcaseId },
        });
        this.name = 'EmptySportShowcaseError';
    }
}

pinClassName(EmptySportShowcaseError, 'EmptySportShowcaseError');
